import GPT3NodeTokenizer from 'gpt3-tokenizer';

import { DEFAULT_TOKENIZER_TYPE } from '@scale/llm-shared/types/defaults';

const tokenizer = new GPT3NodeTokenizer({ type: DEFAULT_TOKENIZER_TYPE });

export function getNumGpt3Tokens(input: string) {
  return tokenizer.encode(input).bpe.length as number;
}
